<template>
  <v-container>
    <v-card class="d-flex justify-start">
      <v-row no-gutters>
        <v-col cols="6">
          <ws-type-selector v-model="FT_ID" :set-global-filter="false" :hide-all-options="true"/>
        </v-col>
        <v-col cols="6">
          <ws-g-o-s-t-selector v-model="GOST" :FT_ID="FT_ID" :set-global-filter="false"/>
        </v-col>
        <v-col cols="12">
          <ws-g-o-s-t-grade-selector v-model="GRADE" :GOST_ID="GOST_ID" :set-global-filter="false"/>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="d-flex justify-start align-center">
      <v-card width="380px" elevation="0" outlined tile>
        <v-chip class="ma-2" color="primary">Название (принятое на производстве)</v-chip>
      </v-card>
      <v-card class="pl-3 pr-3" outlined tile width="100%">
        <v-text-field
          label="Название"
          hint="Название, принятое на производстве"
          persistent-hint
          v-model="ULF_NAME"
        ></v-text-field>
      </v-card>
    </v-card>
    <v-card class="d-flex justify-start align-center">
      <v-card width="380px" elevation="0" outlined tile>
        <v-chip class="ma-2" color="primary">Код (принятый на производстве)</v-chip>
      </v-card>
      <v-card class="pl-3 pr-3" outlined tile width="100%">
        <v-text-field
          label="Код"
          hint="Код, принятый на производстве"
          persistent-hint
          v-model="ULF_CODE"
        ></v-text-field>
      </v-card>
    </v-card>
    <v-card class="d-flex justify-start">
      <v-card outlined tile width="200px">
        <v-chip class="ma-2" color="primary">Комментарий:</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3 pt-3" width="100%">
        <v-textarea
          outlined
          label="Комментарий"
          v-model="ULF_COMMENT"
        ></v-textarea>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import WsTypeSelector from '@/components/modules/projects/ui/wsTypeSelector'
import WsGOSTSelector from '@/components/modules/projects/ui/wsGOSTSelector'
import WsGOSTGradeSelector from '@/components/modules/projects/ui/wsGOSTGradeSelector'
export default {
  name: 'projectCard',
  props: ['project', 'activeTab'],
  components: {
    WsGOSTGradeSelector,
    WsGOSTSelector,
    WsTypeSelector
  },
  data () {
    return {
      localFT: null,
      localGOST: null
    }
  },
  computed: {
    ULF_CODE: {
      get: function () {
        return this.project.ULF_CODE
      },
      set: function (val) {
        this.onChangeProject({ ULF_CODE: val })
      }
    },
    ULF_NAME: {
      get: function () {
        return this.project.ULF_NAME
      },
      set: function (val) {
        this.onChangeProject({ ULF_NAME: val })
      }
    },
    ULF_COMMENT: {
      get: function () {
        return this.project.ULF_COMMENT
      },
      set: function (val) {
        this.onChangeProject({ ULF_COMMENT: val })
      }
    },
    FT_ID: {
      get: function () {
        const ret = this.localFT || this.project.FT_ID
        return ret
      },
      set: function (val) {
        this.localFT = val
      }
    },
    GRADE: {
      get: function () {
        return this.project.GRADE
      },
      set: function (val) {
        this.onChangeProject({
          GRADE: val ? {
            GRADE_ID: val.GRADE_ID,
            GRADE_NAME: val.GRADE_NAME,
            GRADE_CODE: val.GRADE_CODE
          } : {},
          GOST: val ? {
            GOST_ID: val.GOST_ID,
            GOST_NAME: val.GOST_NAME,
            GOST_CODE: val.GOST_CODE,
            OKPD_ID: val.OKPD_ID
          } : {},
          ULF_NAME: val ? val.GRADE_NAME : '',
          ULF_CODE: val ? val.GRADE_CODE : ''
        })
      }
    },
    GOST: {
      get: function () {
        const ret = this.localGOST || (this.project ? this.project.GOST : null)
        return ret
      },
      set: function (val) {
        this.localGOST = val
      }
    },
    GOST_ID: {
      get: function () {
        const ret = this.GOST ? this.GOST.GOST_ID : null
        return ret
      }
    }
  },
  watch: {
    activeTab (val) {
      console.log('projectCard activeTab changed to ', val)
    }
  },
  methods: {
    onChangeProject (val) {
      this.$emit('onChange', val)
    }
  },
  mounted () {
    console.log('projectCard mounted with project ', this.project)
  },
  created () {
    console.log('projectCard created with project ', this.project)
  }
}
</script>
